var map = {
	"./a.png": "5997",
	"./bgMain.png": "ed3d",
	"./brand_logo.png": "e506",
	"./configuration.png": "d62a",
	"./desktop.png": "9a04",
	"./favicon.png": "a171",
	"./gear.png": "165e",
	"./hcl-certified.png": "3c35",
	"./hcl-hero-new.png": "8cfb",
	"./hcl-hero.png": "1382",
	"./laptop.png": "897e",
	"./logo-small.png": "5d57",
	"./logo.png": "4ffd",
	"./reliability.png": "6d8e",
	"./server.png": "1b14",
	"./startup.png": "5d05",
	"./test.png": "35f8",
	"./trustworthy.png": "52cd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";